{
  "appName": "Profiling.app",
  "save": "Guardar",
  "cancel": "Cancelar",
  "loading": "Cargando…",
  "placeholder": "Aquí hay dragones…",
  "resendVerifyEmail": "Reenviar correo de confirmación",
  "nav": {
    "dashboard": "Panel",
    "assignments": "Asignaciones",
    "briefs": "Briefs",
    "evaluations": "Evaluaciones",
    "billing": "Facturación",
    "myProfiles": "Mis perfiles",
    "admin": "Admin",
    "settings": "Configuración",
    "account": "Cuenta",
    "logout": "Cerrar sesión",
    "newWorkspace": "Nuevo espacio de trabajo"
  },
  "pagination": {
    "previous": "Página anterior",
    "next": "Página siguiente",
    "pageOf": "Página {{page}} de {{pages}}"
  }
}
